export enum LOCAL_STORAGE_KEYS {

    TABLE_SPONSORS = "ftdt_spon",
    TABLE_BANNERS = "ftdt_bann",
    TABLE_USERS = "ftdt_user",
    TABLE_PROGRAMS = "ftdt_prog",
    TABLE_BLOGS = "ftdt_blog",

}